export const resolveCustomTaskFieldValue = (
  savedValue,
  defaultValue = "",
  fieldType = "",
) => {
  const hasSavedValue =
    savedValue !== undefined &&
    savedValue !== null &&
    (fieldType === "checkbox" || savedValue !== "");

  return hasSavedValue ? savedValue : defaultValue;
};

export const isCustomTaskCheckboxChecked = (value) =>
  ["1", "true", "yes", "on"].includes(String(value).toLowerCase());

export const shouldApplyCustomTaskSaveResult = (saveVersion, currentVersion) =>
  saveVersion === currentVersion;
